export abstract class BackNavigationService {
  abstract initialize(): void;
  abstract navigateBack(): void;
}
